'use client';

import React from 'react';
import PropTypes from 'prop-types';
import { useGladlyAvailability } from '../../gladly/useGladlyAvailability';

/**
 * Renders nested blocks unless Gladly reports the office is closed.
 * Busy is volume throttling and still counts as available.
 * `null` (not yet known) still renders so a failed read does not hide content.
 */
export const GladlyAvailabilityGate = ({ blocks }) => {
  const availability = useGladlyAvailability();

  if (availability === 'UNAVAILABLE_OFFICE_CLOSED') {
    return null;
  }

  return <>{blocks}</>;
};

GladlyAvailabilityGate.displayName = 'GladlyAvailabilityGate';
GladlyAvailabilityGate.propTypes = {
  blocks: PropTypes.node,
};
